import api from "@/api/api-v2-config";

export async function getEquipmentListAxios() {    
    return await api.get("equipments/equipments?pageNumber=1&pageSize=10000");
}

export async function deleteEquipmentAxios(id) {    
    return await api.delete("equipments/equipments?Id=" + id);
}

export async function postEquipmentAxios(equipment) {    
    return await api.post("equipments/equipments", equipment);
}

export async function putEquipmentAxios(equipment) {    
    return await api.put("equipments/equipments", equipment);
}
export async function uploadMultipleEquipmentDocuments(files, referenceId) {
    console.log("equipments", files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('equipments/diary/files/uploads', formData);

}

export async function getEquipmentDocumentAxios(ReferenceID) {
    return await api.get(`equipments/diary/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function downloadEquipmentDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("equipments/diary/files/download/" + id);
}
export async function deleteEquipmentDocument(id) {
    return await api.delete("equipments/diary/files/" + id);
}